import { parseCoordinates } from '@/vehicle/converters/locationConverters';
import Outlet from '../models/Outlet';
import { DmsConnection } from '../models/common';
import { parseEntities, parseEntity } from './commonConverters';
import { parseCountry } from './countryConverters';

const SCHEMA = {
  id: (data: any) => data.id || data.moboOutletId || data.outletId,
  description: 'description',
  avatar: 'avatar',
  address: 'address',
  secondAddress: 'address2',
  zipCode: 'zipCode',
  vatNumber: 'vatNumber',
  city: 'city',
  companyId: (data: any) => data.companyId ?? data.moboCompanyId,
  isMainOutlet: 'isMainOutlet',
  linked: 'linked',
  country: (data: any) => parseCountry(data.country),
  abbreviation: 'abbreviation',
  hasWorkshopPlanning: 'hasWorkshopPlanning',
  hasWorkshopPlanningLight: 'hasWorkshopPlanningLight',
  hasWorkshopDossiersLicence: 'hasWorkshopDossiersLicence',
  hasWorkshopBookingsLicence: 'hasWorkshopBookingsLicence',
  hasWorkshopPlanningLicence: 'hasWorkshopPlanningLicence',
  hasPickingStatus: 'hasPickingStatus',
  hasWarrantyLicence: 'hasWarrantyLicence',
  hasTimeRegistration: 'hasTimeRegistration',
  requiresCheckInLocation: (data: any) => data.requiredUIFields?.includes('checkInLocation') ?? false,
  requiresSignature: 'hasMandatoryCustomerSignature',
  location: (data: any) => parseCoordinates(data.geoLocation),
  hasSurveyLicence: 'hasCSSLicense',
  hasDBBLicence: 'hasDBBLicence',
  canStartMultipleJobs: (data: any) => data.clockModus !== 'SINGLE',
  hasAutomaticTimeRegistration: (data: any) => data.clockModus !== 'OFF',
  dmsConnections: (data: any) => sortDmsConnections(data.dmsConnections),
  hasContinuousTimeRegistration: (data: any) => data.clockModus === 'STARTSTOP',
  hasCleaningMethodSelection: 'hasCleaningMethodSelection',
  hasInteriorCleaning: 'hasInteriorCleaning',
  hasMandatoryCleaningDecision: 'hasMandatoryCleaningDecision',
};

export function parseOutlet(data: any): Outlet | null {
  return parseEntity(data, SCHEMA, Outlet);
}

export function parseOutlets(data: any): Array<Outlet> {
  return parseEntities(data, SCHEMA, Outlet);
}

export const sortDmsConnections = (dmsConnections: Array<DmsConnection> = []): Array<DmsConnection> => dmsConnections
  .sort((a: DmsConnection, b: DmsConnection) => a.description
    .localeCompare(b.description, 'en', { numeric: true }));